var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from "moment";
export var openInterestAnalysisStreaming = function (data, streaming) {
    return data === null || data === void 0 ? void 0 : data.map(function (x) {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return __assign(__assign({}, x), { change: Number(streaming.changePrice), changePercentage: Number(streaming.changePercentage), latestTradingPrice: Number(streaming.curPrice), latestUpdatedTime: streaming.updatedTime, OI: Number(streaming.openInterest), OIChange: Number(streaming.oiChange), OIChangePercentage: Number(streaming.oiChangePercentage) });
            }
        }
        return x;
    });
};
export var marketFutTodayStream = function (data, streaming) {
    return data.map(function (x) {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return __assign(__assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, stockValue: streaming.curPrice, open: streaming.open, prevClose: streaming.close, openInterest: streaming.openInterest, rollOver: streaming.rollOverCost, rollOverCost: streaming.rollOver, rollOverChangePercentage: streaming.rollOverCostPercentage, 
                    // lastUpdatedTime: getDateInFormat(streaming.updatedTime, "HH:mm:ss"),
                    // spotRate: streaming.spotPrice,
                    // spotRateChangePercentage: streaming.premiumDiscount,
                    volume: streaming.volume, averageTradePrice: streaming.avgTradedPrice, 
                    //  volumeChangePercentage: streaming.volumeChangePercentage,
                    high: streaming.high, low: streaming.low, 
                    // oiAnalysis: streaming.openInterest,
                    oiChangePercentage: streaming.oiChangePercentage, 
                    // status: streaming.marketStatus,
                    lastUpdatedDate: x.status === "Closed"
                        ? x.lastUpdatedDate
                        : moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: x.status === "Closed"
                        ? x.lastUpdatedTime
                        : moment(streaming.updatedTime).format("hh:mm:ss A") });
            }
        }
        return x;
    });
};
export var marketFutStatusStream = function (data, streaming) {
    return data && data.length > 0 && streaming && streaming !== null
        ? data.map(function (x) {
            var _a;
            if (x.exc && streaming.status && ((_a = streaming === null || streaming === void 0 ? void 0 : streaming.status) === null || _a === void 0 ? void 0 : _a[x === null || x === void 0 ? void 0 : x.exc])) {
                return __assign(__assign({}, x), { status: streaming.status[x.exc], lastUpdatedDate: streaming.status[x.exc] === "Closed"
                        ? moment(streaming.lut).format("DD-MMM-YY")
                        : x.lastUpdatedDate, lastUpdatedTime: streaming.status[x.exc] === "Closed"
                        ? moment(streaming.lut).format("hh:mm:ss A")
                        : x.lastUpdatedTime });
            }
            else {
                return x;
            }
        })
        : data
            ? data
            : [];
};
export var drivingMarketStream = function (data, streaming) {
    return data === null || data === void 0 ? void 0 : data.map(function (x) {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return __assign(__assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, lastTradedPrice: streaming.curPrice, 
                    //  volume: streaming.volume, //volume change and vol chgP is not available so remove streaming of vol. Discussed with Jay Thakkar
                    rollOverPercentage: streaming.rollOverCostPercentage, rollOverCost: streaming.rollOver, rollOverCostPercentage: streaming.rollOverCost, 
                    // activeValue: streaming.totalTradedValue,//value change and value chgP is not available so remove streaming of value. Discussed with Jay Thakkar
                    latestUpdatedTime: streaming.updatedTime });
            }
        }
        return x;
    });
};
export var AlertStreamData = function (data, streaming) {
    return data === null || data === void 0 ? void 0 : data.map(function (x) {
        if (x === null || x === void 0 ? void 0 : x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
                return __assign(__assign({}, x), { change: streaming === null || streaming === void 0 ? void 0 : streaming.changePrice, changePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.changePercentage, lastTradedPrice: streaming === null || streaming === void 0 ? void 0 : streaming.curPrice });
            }
        }
        return x;
    });
};
export var CalendarStreamData = function (data, streaming) {
    var _a, _b;
    var filteredData = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.symbol) && (x === null || x === void 0 ? void 0 : x.symbol) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { change: streaming === null || streaming === void 0 ? void 0 : streaming.changePrice, changePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.changePercentage, lastTradedPrice: streaming === null || streaming === void 0 ? void 0 : streaming.curPrice });
        }
        return x;
    });
    var updatedSectionWiseData = {};
    (data === null || data === void 0 ? void 0 : data.sectionWiseData) &&
        ((_b = Object.keys(data === null || data === void 0 ? void 0 : data.sectionWiseData)) === null || _b === void 0 ? void 0 : _b.forEach(function (key) {
            var _a;
            updatedSectionWiseData[key] =
                (_a = data === null || data === void 0 ? void 0 : data.sectionWiseData[key]) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                    if ((item === null || item === void 0 ? void 0 : item.symbol) && (item === null || item === void 0 ? void 0 : item.symbol) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
                        return __assign(__assign({}, item), { change: streaming === null || streaming === void 0 ? void 0 : streaming.changePrice, changePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.changePercentage, lastTradedPrice: streaming === null || streaming === void 0 ? void 0 : streaming.curPrice });
                    }
                    return item;
                });
        }));
    return {
        sectionWiseData: updatedSectionWiseData,
        data: filteredData,
    };
};
